import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import {
  FormUtility,
  withAuthentication,
  withProfileApi,
  withRouter,
} from "cw-styleguide-react";
import qs from "qs";
import CoursesTranslateManageView from "../../views/translate/CoursesTranslateManageView";
import i18n from "../../../../i18n";
import { TRANSLATOR_UNASSIGNED } from "../../../../constants";
import { route } from "../../../../routes";

class CoursesTranslateManageController extends Component {
  constructor(props) {
    super(props);

    const parameters = this.convertParametersToFilters(
      this.props.location.search
    );

    const merged = {
      ...{
        courseId: "",
        courseTitle: "",
        statuses: parameters.status ? parameters.status : "",
        translatorAssigned: parameters.translatorAssigned
          ? parameters.translatorAssigned
          : "",
        mainProviderId: "",
        mainProviderLabel: "",
        order: "rel",
        page: 1,
        groupSize: "10",
      },
      ...parameters,
    };

    // Set the initial state of the form filter values.
    this.state = {
      filterValues: merged,
      translators: [],
    };

    // Bind functions to this.
    this.handleReset = this.handleReset.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadTranslators = this.loadTranslators.bind(this);
    this.handleStateChange = this.handleStateChange.bind(this);
  }

  /**
   * componentDidMount.
   */
  componentDidMount() {
    this.loadTranslators();

    // Only clear the messages if we haven't just redirected here.
    if (this.props.redirect) {
      this.props.clearRedirect();
    } else {
      this.props.clearMessages();
    }
  }

  componentDidUpdate(prevProps) {
    // If redirected to itself then reload the pager
    // See https://dev.azure.com/ccdg/CWO%20-%20Courses/_workitems/edit/6425
    if (this.props.redirect !== prevProps.redirect) {
      if (this.props.redirect === route("coursesTranslateManage")) {
        this.props.clearRedirect();
        this.props.setReloadKey();
      }
    }
  }

  /**
   * loadTranslators
   */
  loadTranslators() {
    if (this.props.authentication.hasRole("Courses_Translator")) {
      this.setState({
        translators: [
          {
            value: this.props.authentication.getClaim("atlasId"),
            label: this.props.authentication.getClaim("name"),
          },
        ],
      });
    } else {
      // Make sure we have the list of translators loaded and ready.
      this.props.profileApiGetWebcontactTranslators(
        i18n.language,
        (response) => {
          let translators = response.data.map((element) => ({
            value: element.atlasId,
            label: element.name,
          }));

          this.setState({
            translators: translators,
          });
        },
        (error) => {}
      );
    }
  }

  /**
   * Handle the form change event and set the values in the form state.
   * @param event
   */
  handleChange(event) {
    const values = { ...this.state.filterValues };

    this.setState({
      filterValues: FormUtility.setFormValues(event, values),
    });
    this.props.clearSelected();
  }

  /**
   * Reset the filters.
   * @param event
   */
  handleReset(event) {
    this.setState({
      filterValues: {
        courseId: "",
        courseTitle: "",
        statuses: "",
        translatorAssigned: TRANSLATOR_UNASSIGNED,
        mainProviderId: "",
        mainProviderLabel: "",
        order: "rel",
        page: 1,
        groupSize: "10",
      },
    });

    this.props.setReloadKey();
  }

  handleSubmit(event) {
    event.preventDefault();

    this.props.setReloadKey();
  }

  /**
   * convertParametersToFilters
   * @param parameters
   * @returns {any}
   */
  convertParametersToFilters(parameters) {
    const params = qs.parse(parameters, { ignoreQueryPrefix: true });

    // Remove empty parameter filters.
    Object.keys(params).forEach((key) => {
      params[key] = Array.isArray(params[key])
        ? new Set(params[key])
        : params[key];
      if (!params[key] || params[key].length === 0) {
        delete params[key];
      }
    });

    return params;
  }

  /**
   * convertFiltersToParameters
   * @param filters
   * @returns {string}
   */
  convertFiltersToParameters(filters) {
    let params = {
      courseId: filters.courseId,
      courseTitle: filters.courseTitle,
      statuses: filters.statuses,
      translatorAssigned: filters.translatorAssigned,
      mainProviderId: filters.mainProviderId,
      mainProviderLabel: filters.mainProviderLabel,
      order: filters.order,
      groupSize: filters.groupSize,
      page: filters.page,
    };

    // Remove empty filter parameters.
    Object.keys(params).forEach((key) => {
      if (!params[key] || params[key].length === 0) {
        delete params[key];
      }
    });

    return qs.stringify(params, {
      addQueryPrefix: true,
      arrayFormat: "brackets",
    });
  }

  handleStateChange(data) {
    this.props.clearSelected();

    const values = { ...this.state.filterValues };

    values["order"] = data.order;
    values["groupSize"] = data.groupSize;
    values["page"] = data.page;

    let parameters = this.convertFiltersToParameters(values);

    console.log("P", parameters);
    console.log("V", values);

    this.props.clearRedirect();
    this.props.navigate(route("coursesTranslateManage") + parameters);
    this.props.setQuery(parameters);
  }

  /**
   * Render
   * @returns {JSX.Element}
   */
  render() {
    return (
      <CoursesTranslateManageView
        {...this.props}
        {...this.state}
        handleReset={this.handleReset}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        handleStateChange={this.handleStateChange}
      />
    );
  }
}

export default withRouter(
  withProfileApi(process.env)(
    withAuthentication(
      withTranslation("local")(CoursesTranslateManageController)
    )
  )
);
